import { render } from "./GenInput.vue?vue&type=template&id=a314d3c6"
import script from "./GenInput.vue?vue&type=script&lang=js"
export * from "./GenInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__